const SQLBuilderItem = {
  actQuery: [{
    sid: '{E301E073-F0C0-42C8-9D92-D21DA58B9F40}',
    tableName: 'BN_SYS_USER',
    tableCaption: '用户信息',
    kind: 'select'
  }, {
    sid: '{2B0C84D7-1DE6-45BF-BCD5-834BBC813E85}',
    tableName: 'BN_SYS_SERVICES',
    tableCaption: '服务列表',
    kind: 'select'
  }, {
    sid: '{EE032563-DBEB-4AF3-B7EC-852661F15B94}',
    tableName: 'BN_SYS_PURVIEW_ITEMS',
    tableCaption: '功能列表',
    kind: 'select'
  }]
}

export default SQLBuilderItem



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-login/action.js